var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-form-review" },
    _vm._l(_vm.validSections, function(ref, index) {
      var heading = ref.heading
      var sectionId = ref.sectionId
      var items = ref.items
      return _c(
        "section",
        { key: index, staticClass: "c-form-review__section" },
        [
          _c("header", { staticClass: "c-form-review__header" }, [
            _c("h3", { staticClass: "c-form-review__heading" }, [
              _vm._v(_vm._s(heading))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "c-form-review__button",
                attrs: { type: "button", "aria-label": "Edit section" },
                on: {
                  click: function($event) {
                    return _vm.handleEditClick({
                      sectionId: sectionId,
                      sectionIndex: index
                    })
                  }
                }
              },
              [_vm._v("Edit")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form-review__content" },
            _vm._l(_vm.validItems(items), function(item, index) {
              return _c(
                "p",
                { key: index, staticClass: "c-form-review__item" },
                [
                  _c("span", { staticClass: "c-form-review__title" }, [
                    _vm._v(_vm._s(item.title) + ":")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "c-form-review__description" }, [
                    _vm._v(_vm._s(item.description))
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8656100c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8656100c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/form-review/FormReview.vue
// module id = 724
// module chunks = 0